(function () {
  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function initCountdown(el) {
    var targetStr = el.getAttribute('data-target');
    if (!targetStr) return;
    // Normalize "YYYY-MM-DD HH:MM" → "YYYY-MM-DDTHH:MM" para Safari/iOS
    var normalized = targetStr.replace(' ', 'T');
    if (normalized.length === 16) normalized += ':00'; // add seconds
    var target = new Date(normalized).getTime();
    if (isNaN(target)) return;

    var endedMsg = el.getAttribute('data-ended-msg') || '¡Oferta terminada!';
    var daysEl = el.querySelector('[data-days]');
    var hoursEl = el.querySelector('[data-hours]');
    var minutesEl = el.querySelector('[data-minutes]');
    var secondsEl = el.querySelector('[data-seconds]');
    var showDays = !!daysEl;
    var interval = null;

    function tick() {
      var now = Date.now();
      var diff = target - now;
      if (diff <= 0) {
        if (interval) clearInterval(interval);
        el.innerHTML = '<span class="mc-banner-promo__cd-ended">' + endedMsg + '</span>';
        return;
      }
      var totalSec = Math.floor(diff / 1000);
      var d = Math.floor(totalSec / 86400);
      var h = Math.floor((totalSec % 86400) / 3600);
      var m = Math.floor((totalSec % 3600) / 60);
      var s = totalSec % 60;

      if (showDays) {
        daysEl.textContent = pad(d);
      } else {
        // sumar días a las horas
        h = Math.floor(totalSec / 3600);
      }
      if (hoursEl) hoursEl.textContent = pad(h);
      if (minutesEl) minutesEl.textContent = pad(m);
      if (secondsEl) secondsEl.textContent = pad(s);
    }

    tick();
    interval = setInterval(tick, 1000);
  }

  function initAll() {
    document.querySelectorAll('[data-mc-countdown]').forEach(initCountdown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
